import { StrictMode } from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import axios from "axios";
// import LogRocket from "logrocket";
// import setupLogRocketReact from "logrocket-react";
// import ReactGA from "react-ga4";

//components
import { store, persistor } from "redux/store";
import App from "components/App";

//css
import "./scss/main.scss";

const container = document.getElementById("root");
const root = createRoot(container);

// if (process.env.__MODE__ !== "development") {
// 	ReactGA.initialize("G-VWE270QPTE");
// 	LogRocket.init("5p7c3d/airlines-group-manager");
// 	setupLogRocketReact(LogRocket);

// 	LogRocket.getSessionURL(function (sessionURL) {
// 		ReactGA.send({
// 			hitType: "event",
// 			eventCategory: "LogRocket",
// 			eventAction: sessionURL
// 		});
// 	});
// }

axios.defaults.withCredentials = true;

root.render(
	<StrictMode>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<App />
			</PersistGate>
		</Provider>
	</StrictMode>
);

serviceWorkerRegistration.register();
